function getEvents(pageId) {
  if (
    process.env.STORYBOOK_DISABLE_ANIMATIONS === "1" ||
    process.env.STORYBOOK_DISABLE_ANIMATIONS
  ) {
    return {};
  }
  return {
    events: {
      e: {
        id: "e",
        name: "",
        animationType: "custom",
        eventTypeId: "SCROLLING_IN_VIEW",
        action: {
          id: "",
          actionTypeId: "GENERAL_CONTINUOUS_ACTION",
          config: { actionListId: "a", affectedElements: {}, duration: 0 },
        },
        mediaQueries: ["main", "medium", "small", "tiny"],
        target: {
          id: `${pageId}|c312f05d-6016-23ad-061e-08a66a5c3384`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|c312f05d-6016-23ad-061e-08a66a5c3384`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: [
          {
            continuousParameterGroupId: "a-p",
            smoothing: 50,
            startsEntering: true,
            addStartOffset: false,
            addOffsetValue: 50,
            startsExiting: false,
            addEndOffset: false,
            endOffsetValue: 50,
          },
        ],
        createdOn: 1681735738804,
      },
    },
    actionLists: {
      a: {
        id: "a",
        title: "Layout 414 Images [Scroll]",
        continuousParameterGroups: [
          {
            id: "a-p",
            type: "SCROLL_PROGRESS",
            parameterLabel: "Scroll",
            continuousActionGroups: [
              {
                keyframe: 0,
                actionItems: [
                  {
                    id: "a-n",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        useEventTarget: "CHILDREN",
                        selector: ".layout414_image-list.image-list-top",
                        selectorGuids: [
                          "33d44eb2-5ff2-032a-0eff-0575ae768927",
                          "33d44eb2-5ff2-032a-0eff-0575ae76892e",
                        ],
                      },
                      xValue: -2,
                      xUnit: "%",
                      yUnit: "PX",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-n-2",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        useEventTarget: "CHILDREN",
                        selector: ".layout414_image-list.image-list-bottom",
                        selectorGuids: [
                          "33d44eb2-5ff2-032a-0eff-0575ae768927",
                          "33d44eb2-5ff2-032a-0eff-0575ae76892f",
                        ],
                      },
                      xValue: 2,
                      xUnit: "%",
                      yUnit: "PX",
                      zUnit: "PX",
                    },
                  },
                ],
              },
              {
                keyframe: 100,
                actionItems: [
                  {
                    id: "a-n-3",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        useEventTarget: "CHILDREN",
                        selector: ".layout414_image-list.image-list-top",
                        selectorGuids: [
                          "33d44eb2-5ff2-032a-0eff-0575ae768927",
                          "33d44eb2-5ff2-032a-0eff-0575ae76892e",
                        ],
                      },
                      xValue: 5,
                      xUnit: "%",
                      yUnit: "PX",
                      zUnit: "PX",
                    },
                  },
                  {
                    id: "a-n-4",
                    actionTypeId: "TRANSFORM_MOVE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        useEventTarget: "CHILDREN",
                        selector: ".layout414_image-list.image-list-bottom",
                        selectorGuids: [
                          "33d44eb2-5ff2-032a-0eff-0575ae768927",
                          "33d44eb2-5ff2-032a-0eff-0575ae76892f",
                        ],
                      },
                      xValue: -5,
                      xUnit: "%",
                      yUnit: "PX",
                      zUnit: "PX",
                    },
                  },
                ],
              },
            ],
          },
        ],
        createdOn: 1681735748815,
      },
    },
    site: {
      mediaQueries: [
        { key: "main", min: 992, max: 10000 },
        {
          key: "medium",
          min: 768,
          max: 991,
        },
        { key: "small", min: 480, max: 767 },
        { key: "tiny", min: 0, max: 479 },
      ],
    },
  };
}

// eslint-disable-next-line import/no-default-export
export default getEvents;
